<template>
    <div v-if="menu.can_edit">
        <a href="#" @click="showConfirmationModal()">
            <i class="fas fa-fw fa-trash-alt text-danger"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: 'DropMenuDeadline',

    props: {
        menu: {},
    },

    methods: {
        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer cette échéance ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: false,
                    }
                )
                .then((value) => {
                    //
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteItem() {
            try {
                await axios.delete(`/clientDeadlines/${this.menu.deadline_id}`)
                this.$root.$refs.clientDeadlinesTable.getItems()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
